import {BehaviorSubject, Observable} from "rxjs/Rx";
import {CookieHandler} from '@/helpers/CookieHandler';
import { webappLink} from "@/services/endpoints";
import {domainFolder, isSecure} from "@/helpers/DomainHelpers";
import {getToken, removeToken, setToken} from "@/services/tokenService";

export class AuthService {

  public readonly authToken$$: BehaviorSubject<string>; // token stream
  public readonly whenNoToken$$: Observable<string>; // stream for when we have no token
  public readonly whenExistsToken$$: Observable<string>; // Stream for when we have token
  private tokenVerified: boolean;
  private cookies: CookieHandler;
  private readonly oldToken: string;

  constructor() {
    this.oldToken = getToken() || ''; // we save the old token
    this.tokenVerified = false;
    this.cookies = new CookieHandler(7, webappLink(), domainFolder(), isSecure());
    this.authToken$$ = new BehaviorSubject<string>("");
    this.whenNoToken$$ = this.authToken$$.filter((token: string) => token === "");
    this.whenExistsToken$$ = this.authToken$$.filter((token: string) => token !== "");
  }

  public nextToken(token: string) {
    setToken(token);
    this.authToken$$.next(token);
  }

  public clearToken() {
    removeToken();
    this.authToken$$.next("");
  }

  public getOldToken() {
    // originally I wanted to put here the testing of the token. However, for that I need ApiCaller
    // and apiCaller needs this service, so it should be done outside both classes. But the stream also
    // updates the token, so I keep this saved here.
    return this.oldToken;
  }
}
